import { render, staticRenderFns } from "./prescription.vue?vue&type=template&id=b01ee104"
import script from "./prescription.vue?vue&type=script&lang=js"
export * from "./prescription.vue?vue&type=script&lang=js"
import style0 from "./prescription.vue?vue&type=style&index=0&id=b01ee104&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b01ee104')) {
      api.createRecord('b01ee104', component.options)
    } else {
      api.reload('b01ee104', component.options)
    }
    module.hot.accept("./prescription.vue?vue&type=template&id=b01ee104", function () {
      api.rerender('b01ee104', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/applications/prescription.vue"
export default component.exports